const breadCrumb =
  "Lotação de Servidores - Consultas de Informações do Servidor";

const routes = [
  {
    path: "/consulta-de-turmas-sem-professor",
    name: "consulta-de-turmas-sem-professor",
    meta: {
      allowedPermissions: ["turma_list", "turma_pdf"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ConsultaDeTurmasSemProfessor/ConsultaDeTurmasSemProfessor.vue"
      ),
  },
];

export default routes;
